<template>
  <div class="error-page">
    <main-image-section></main-image-section>
    <div class="container">
      <div class="row">
        <div class="col text-center font-default">
          <div class="block p-t">
            <h2 class="fnt font-default-light">
              {{ $t("SHARED__ERROR_PAGE_MSG") }}
            </h2>
          </div>

          <div class="content-narrow">
            <div class="block p-t-b">
              <el-button type="primary" @click="goHome" class="w100">
                {{ $t("SHARED__RESTART_BTN") }}
                <i class="fas fa-plane"></i>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainImageSection from "../components/Layout/MainImageSection"

export default {
  name: "Error",
  components: {
    MainImageSection
  },
  methods: {
    goHome() {
      this.$router.push({ name: "home" })
    }
  }
}
</script>

<style scoped></style>
